 var globalFrameIDForTextToAlign = null;   
         var currentFrameID = null;  
         var currentElementID = null;  
         var StrapCurrentFrame = null;
         var StrapCurrentFrameBoundingBox = null;
         var NormalImagesCurrentFrameBoundingBox = null;  
         var frameJson = [];  
         var frameId = null;         
         var fonts = null;
         var fonts_order = null;
         var text_color = null;
         var text_size = null;
         var text_border_color = null;  
         var custom_font_css = null;    
         var icons = null;
         var designsProductJSON = null;
         var boundingBoxJSON = null;
         var check_previous_saved_setting = null;  
         var max_image_size = null;
         var max_character_allowed = null;
         var max_text_layer_allowed = null;
         var max_image_allowed = null;
         var straps_data = null;
         var image_template_width = null;
         var image_template_height = null;

        // price for character and type 
         var text_price = 0;
         var text_price_type = null;
           
        // price for image and type
           
         var image_price = 0;
         var image_price_type = null;   
           
        // variant price
         var variant_price = 0;  
           
        // total price calculation
        var total_price = 0;
           
        //price array
        var price_array = new Array();   
           
        // fetch custom design for selected variant
        var strap_position = "";
        var editor_mode_hide = "";
        var text_position = "";
        var textBoundingBoxMode = "";
        var textBoundingBox = {};
        var text_alignment = ""; 

        // prj code
        var fixed_text = "";
        var fixed_text_color = "";
        var fixed_text_border_color = "";
        var fixed_text_no_of_letters ="";
        var fixed_text_font_family ="";
        var fixed_text_ipod = "";
         //end

        var file_uploade_hide ="";

        function get_custom_design_settings(variant_id)
        {
                           $.ajax({
                                //url       : "https://webdevfolio.com/shopifyapps/Concepto-version2/fetch_customize_settings",
                                url:"https://conceptodohaapp.com/fetch_customize_settings",
                                type      : "POST",
                                crossDomain : true,
                                async       : true,
                                cache       : false,
                                dataType    : 'json',
                                //data      : { 'variant_id' : variant_id},
                                data      : { 'variant_id' : variant_id,'ip_address' : ip_address,'customer_id' : customer_id},
                                success     : function (result) {
                                  console.log(result);
                                  //alert(result.success);
                                  		if(result.success == true)
                                        {
                                     

                                          text_position =  result.text_position; //"strap";
                                          editor_mode_hide = result.editor_mode_hide; 
                                          strap_position = result.strap_position; // "right_strap";
                                          file_uploade_hide = result.file_uploade_hide;
                                          console.log(file_uploade_hide);
                                         $(".customizer_button").show();
                                         $(".custom_buy_now_btn").show(); 
                                  		 icons = result.icon;


                                        if(editormode_chk()) {
                                             var tempicons = new Array();
                                            for(i=0; i< icons.length; i++){
                                              if(icons[i].image_category != "Painting"){
                                                tempicons.push(icons[i]);
                                              }
                                            }
                                            
                                            icons = tempicons;
                                          }
                                          
                                         straps_data = result.straps_data; 
                                  		 fonts = result.google_fonts;
                                         fonts_order =  JSON.parse(JSON.stringify(result.google_fonts)); //jQuery.extend(true, {},  result.google_fonts); 
                                  		 text_color = result.text_color;
                                  		 text_size = result.text_size;
                                  		 text_border_color = result.text_border_color;	
                                  		 custom_font_css = result.custom_font_css;
                                          
                                         max_image_size = result.image_setting.max_image_size;
                                         max_image_allowed = result.image_setting.max_image_allowed;                                          
                                         max_character_allowed = result.character_setting.max_character_allowed;
                                          
                                         image_template_width =  result.image_template_width;
                                         image_template_height =  result.image_template_height;
                                          
                                         text_price = result.character_setting.text_price;
                                         text_price_type = result.character_setting.price_type;
                                         max_text_layer_allowed = result.character_setting.max_text_layer_allowed;
                    
                                          
                                         image_price = result.image_setting.image_price;
                                         image_price_type = result.image_setting.price_type;
                                         
                                         price_text = $("#variant_price").text().trim();
                                          
                                          
                                         //price_text = price_text.split("$");
                                          price_text = price_text.split("QAR");
                                          
                                          
                                         variant_price = parseFloat(price_text[1]); 
                                                   
                                        $("#final_customize_price").text($("#variant_price").text()); 
                                  		 designsProductJSON = result.product_design;
                                         boundingBoxJSON = {"width": parseInt(result.permissible_area.width),"height": parseInt(result.permissible_area.height),"y": parseInt(result.permissible_area.y_axis),"x": parseInt(result.permissible_area.x_axis)};	
                                       

                                         //prj code 

                                           if(result.fixed_text)
                                              {
                                                    fixed_text = result.fixed_text;
                                                    fixed_text_color = result.fixed_text_color;
                                                    fixed_text_border_color = result.fixed_text_border_color;
                                                    fixed_text_no_of_letters = result.fixed_text_no_of_letters;
                                                    fixed_text_font_family = result.fixed_text_font_family;
                                              }
                                              //Megha code
                                            if(result.fixed_text_ipod == "yes")  
                                             {
                                                fixed_text_ipod = result.fixed_text_ipod;
                                             }


                                          
                                         check_previous_saved_setting = result.check_previous_saved_setting;
                                          

                                        // enable/ disable custom product button based on soldout/unavailable
                                       if($(".price--unavailable").length > 0) {
                                        console.log("Hide custom button unavailable");
                                         $(".customizer_button").hide();
                                         }      

                                       if($(".price--sold-out").length > 0) {
                                        console.log("Hide custom button soldout");
                                         $(".customizer_button").hide();
                                         $(".custom_buy_now_btn").hide();
                                         } 

                                        if ($(".single_add_to_cart_button").attr('disabled') !== undefined) {
                                          $(".customizer_button").hide();
                                          $(".custom_buy_now_btn").hide();
                                        } else {
                                          $(".customizer_button").show();
                                          $(".custom_buy_now_btn").show();
                                        }

                                          
                                        }
                                  		else
                                        {
                                            //BUY NOW BUTTON HIDE_SHOW AS PER SOLDOUT
                                            if ($(".single_add_to_cart_button").attr('disabled') !== undefined) {
                                              $(".custom_buy_now_btn").hide();
                                            } else {
                                              $(".custom_buy_now_btn").show();
                                            }
                                            //BUY NOW BUTTON HIDE_SHOW AS PER SOLDOUT
                                          
                                         $(".customizer_button").hide();
                                         check_previous_saved_setting = null;
                                          
                                          
                                        }

                                 
                                  
                                  
                                         //boundingBoxJSON = {"width": 100,"height": 100,"y": 100,"x": 100};		
        // return false;
                                },
                                complete    : function(result1) {
                                }
                            }); 
          
                             }

                    function openCity(evt, cityName) {
                        var i, tabcontent, tablinks;
                        tabcontent = document.getElementsByClassName("tabcontent");
                        for (i = 0; i < tabcontent.length; i++) {
                            tabcontent[i].style.display = "none";
                        }
                        tablinks = document.getElementsByClassName("tablinks");
                        for (i = 0; i < tablinks.length; i++) {
                            tablinks[i].className = tablinks[i].className.replace(" active", "");
                        }
                        document.getElementById(cityName).style.display = "block";
                        evt.currentTarget.className += " active";
                    }

                    // Get the element with id="defaultOpen" and click on it
                    //document.getElementById("defaultOpen").click();


                    // to show and hide .mainPopup modal

                    $(document).ready(function () {

                        if(editormode_chk()){
                             jQuery('.custom-image-upload').remove();
                          }

                      
                      
                        $(document).on("click", ".customizer_button", function () {
                          
                          $(".mainPopup").show();
                          if($(window).width() < 750)
                          {
                            console.log("Window < "+$(window).width);          
                            $("body").addClass("bodyScrollEdreamz");

                          }
                            load_product_customzier();
                        /*  if(editormode_chk1()){
                            console.log($('.image-upload-item'));
                             $('.image-upload-item').css("display","none");
                          }*/
                          setTimeout( function() { editormode_chk1(); }, 3000);
                          
                        });
                      
                        $(document).on("click", ".close", function () {

                            $(".mainPopup").hide();
                          	$("body").removeClass("bodyScrollEdreamz");
        					location.reload();
                        });
                      
                              $('.mainPopup').on('click', '#add-custom-image-btn', function(e){
                               // alert(jQuery('.image-upload-item:visible').length);
                                if($('.image-upload-item:visible').length + 1 > max_image_allowed){
                                  alert("User can not upload more than "+max_image_allowed+" images");
                                  return;
                                }
                                $('.custom-image-container').append($('.image-upload-item:first').clone());
                            }) 
                            
                           
                             $('.mainPopup').on('click', '.add-more-text-element', function(e){
                                     e.stopPropagation();
                                if($('.input-text-element').length > max_text_layer_allowed){
                                  alert('User can not add more than '+max_text_layer_allowed+' text element');
                                	return;
                                }
                                
                                $('.border-picker').removeClass("active-border-color-element");
                                $('.color-picker').removeClass("active-color-element");
                                 
                              	insert_text_html_element($(this));
                                // $.validator.addClassRules("input-text-element", { maxlength: 10 });
                            })  
                              
                           $('.mainPopup').on('change', '.text-alignent-radio', function(e){
                                
                                console.log("currentelementId==>",currentelementId);

                                console.log("globalFrameIDForTextToAlign==>",globalFrameIDForTextToAlign);
                             
                                console.log('text-alignent-radio - '+$(this).val());
                                // var currentelement = yourDesigner.currentViewInstance.getElementByID(currentelementId);         
                                 var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);         
                                
                                var element_value = $(this).val();	
                                 obj = render_allignment(element_value, currentelement);
                                obj['custom_text_allignment'] = element_value;
                                
                                  var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);                     
                                
                                
                            })          
                              
                               $('.mainPopup').on('change', '.custom-font-css', function(e){
                                
                              
                                 var currentelement = yourDesigner.currentViewInstance.getElementByID(currentelementId);         
                                
                                 var element_value = $(this).val();
                                 var search_custom_css = getDetailsByAttr(custom_font_css, 'id', element_value);
                                 search_custom_css.custom_css = search_custom_css.id;
                                 
                                 delete search_custom_css.id;
                                 delete search_custom_css.name;
                                 
                                 console.log(search_custom_css, element_value);
                                  var element = yourDesigner.currentViewInstance.setElementParameters(search_custom_css[0], currentelement);                      
                            })          
                    });
           
           
           function render_allignment(element_value, currentelement){
             	 var obj = new Object;
                               // console.log(element_value);
                                if(element_value == "Horizontal")                          
                                {
                                  
                                  obj['text'] = currentelement.original_text;
                                  //console.log(currentelement.original_text);
                                  
                                }
                                else
                                {
                                  obj['text'] = chunk(currentelement.original_text, 1);
                                    //  console.log(obj);
                                }
             return obj;
           }
                    var flag = 0;
                    var elementIdArr = [] ;
                    var currentelementId = "";
                    var click_bind = 0;
                    function load_product_customzier() {
                             console.log(fonts);
                        //fonts[0].url = "https://cdn.shopify.com/s/files/1/0016/9007/5203/t/16/assets/Amiri_Italic_400.ttf";
                      
                        var $yourDesigner = $('#clothing-designer'),
                                pluginOpts = {
                                    productsJSON: designsProductJSON, //see JSON folder for products sorted in categories
                                    designsJSON: icons, //see JSON folder for designs sorted in categories
                                    strapsJSON: straps_data, //see JSON folder for designs sorted in categories
                                    stageWidth: image_template_width,
                                    stageHeight: image_template_height,
                                    editorMode: false,
                                    smartGuides: true,
                                    //uiTheme: 'doyle',
                                    initialActiveModule: "text",
                                    mainBarModules: ['text', 'designs', 'manage-layers'],
                                    fonts: fonts,
                                    boundingBox: boundingBoxJSON
                                    ,
                                    boundingBoxMode: 'limitModify',
                                    customTextParameters: {
                                        colors: true,
                                        removable: false,
                                        resizable: true,
                                        draggable: true,
                                        rotatable: true,
                                        autoCenter: true,
                                        boundingBox: "Base",
                                        curvable: true,
                                      	topped: true,
                                        "boundingBoxMode": "limitModify",
                                        boundingBox: boundingBoxJSON
                                    },
                                    customImageParameters: {
                                        draggable: true,
                                        removable: true,
                                        resizable: true,
                                        rotatable: true,
                                        copyable: false,
                                        colors: '#000',
                                        autoCenter: true,
                                        "boundingBoxMode": "limitModify",
                                        "boundingBox": boundingBoxJSON,
                                    },
                                    actions: {
                                        // 'top': ['download','print', 'snap', 'preview-lightbox'],
                                        // 'right': ['magnify-glass', 'zoom', 'reset-product', 'qr-code', 'ruler'],
                                        // 'bottom': ['undo','redo'],
                                        // 'left': ['manage-layers','info','save','load']
                                    }
                                };
                      
                      
                      yourDesigner = new FancyProductDesigner($yourDesigner, pluginOpts);
                      

            $yourDesigner.on('elementAdd', function(evt, fabricObject){

                                    if(fabricObject.custom_type == "text"){
                                        currentelementId = fabricObject.id;                                
                                        elementIdArr[fabricObject.custom_index] = fabricObject.id;
                                        global_image_category = "text";
                                    }
                          
                          
                          			// added to solve default text issue here we are assigning elementIdArr to currentelementId
                          			currentelementId = elementIdArr;
                                    globalFrameIDForTextToAlign = elementIdArr;
                                     
                                     console.log(fabricObject);   
                          
                          
                         
                                    if(fabricObject.title == "Base")
                                    {

                                        console.log("base");
                                      frameId = fabricObject.id;
                                      
                                     if(fixed_text.length == 0){ 

                                            StrapCurrentFrame = { "left": fabricObject.left, "top": fabricObject.top, "width": fabricObject.width, "height": fabricObject.height}    
                                           
                                            StrapCurrentFrameBoundingBox = {"width" : StrapCurrentFrame.width, "height": StrapCurrentFrame.height, y: 47, x: -3};

                                              if(strap_position == "right_strap"){
                                                StrapCurrentFrameBoundingBox = {"width" : StrapCurrentFrame.width, "height": StrapCurrentFrame.height, y: 40, x: 55};  
                                              }
                                      
                                      }
                                      
                                      
                                    }
                          
                                if(global_image_category == "Strap")
                                    {
                                        console.log("Strap");
                                    currentElementID = fabricObject.id;  
                                      
        						      var currentelementId = fabricObject.id;		
                                      var frameData = {id: currentelementId, type: "image"};
                                      
                                       if(typeof frameJson[currentelementId] == "undefined"){                                  
                                        	frameJson[currentelementId] = new Array();	
                                      	}
                                      
                                      
                                      frameJson[currentelementId].push(frameData);
                                      var current_frame_image = getDetailsByAttr(frameJson[currentelementId], 'type', "image");

                                      
                                      
                                    }
                          			
                          
                          
                          
                         
                                if(fabricObject.category != "strap_images" && fixed_text_ipod != 'yes')
                                {
                                  console.log("strap_images")
                                          calculate_price();
                                }
                          
                    });
                      
                       $yourDesigner.on('elementRemove', function(evt, fabricObject){

                                    console.log("remove");
                         			//elementIdArr();
                         			if(fabricObject != null){              
                                        if(fabricObject.custom_type == "text"){
                                          var index = search_index(elementIdArr, fabricObject.id);
                                          if(index != -1){
                                            delete elementIdArr[index];
                                            $('.input-text-element[data-index="' + index + '"]').val('');
                                        }  
                                    }  
                                    }
                          			calculate_price();
                            });

                        $yourDesigner.on('elementSelect', function(evt, fabricObject){

                            console.log("select");

                                




                                    if(fabricObject != null){              
                                        if(fabricObject.custom_type == "text"){
                                          
                                           currentelementId = fabricObject.id;
                                          
                                        $('.custom-google-fonts').val(fabricObject.fontFamily);         
                                        $('.custom-font-size').val(fabricObject.fontSize);


                                        $('.color-picker').removeClass("active-color-element");
                                        $('input[value="' + fabricObject.fill + '"].color-picker').addClass("active-color-element");
                                        $('.border-picker').removeClass("active-border-color-element");
                                        $('input[value="' + fabricObject.shadowColor + '"].border-picker').addClass("active-border-color-element");


                                        $('input[value="' + fabricObject.custom_text_allignment + '"]').prop("checked", true);
                                        $('input[value="' + fabricObject.custom_text_allignment + '"]:first').trigger("click");

                                        
                                        }  
                                    }                            
                            });
        				
                      	
                        $yourDesigner.on('ready', function () {  
                          	
                         
                          
                          	$(".fpd-content").append('<span id="scrollDownSpan"></span>');
                         
                          
                               $yourDesigner.on("productCreate", function(){

                               if(check_previous_saved_setting != null){
                            
                             check_previous_saved_setting = JSON.stringify(check_previous_saved_setting).replace(/"false"/g, false);
                             check_previous_saved_setting = check_previous_saved_setting.replace(/"true"/g, true);
                             check_previous_saved_setting = JSON.parse(check_previous_saved_setting);;
                            var custom_element = check_previous_saved_setting[0].elements;
                                 
                                 
                             for(var j=1; j < custom_element.length; j++){

                              
                               
                               if(custom_element[j].parameters.custom_type == "text"){
                                 
                                 custom_element[j].source = String(custom_element[j].parameters.original_text);
                                 custom_element[j].title = String( custom_element[j].parameters.original_text );
                                 custom_element[j].parameters.text = String( custom_element[j].parameters.text);
                                 custom_element[j].parameters.original_text = custom_element[j].parameters.original_text;
                                 
                                 if(j > 1){

                                   insert_text_html_element($('.add-more-text-element:first'));
                                 }
                                 
                                 $('.input-text-element').eq([j-1]).val(custom_element[j].parameters.original_text); //.trigger("keyup");
                                 custom_element[j].parameters.custom_index = j - 1;  
                                 elementIdArr[custom_element[j].parameters.custom_index] = 0;

                                 if(fixed_text.length == 0){

                                 var element = yourDesigner.currentViewInstance.addElement("text", custom_element[j].parameters.text, custom_element[j].parameters.text, {
                                        custom_type: "text",
                                      original_text: custom_element[j].parameters.original_text,
                                      custom_text_allignment: custom_element[j].parameters.custom_text_allignment,
                                        colors:true,
                                        color: "#fff",
                                   fontSize: custom_element[j].parameters.fontSize,
                                    strokeBlur: custom_element[j].parameters.strokeBlur,
                                        shadowOffsetX: custom_element[j].parameters.shadowOffsetX,
                                        shadowOffsetY: custom_element[j].parameters.shadowOffsetY,
                                   shadowColor:  custom_element[j].parameters.shadowColor,
                                        fill: custom_element[j].parameters.fill,  
                                   fontFamily: custom_element[j].parameters.fontFamily,  
                                        price: 20,
                                        "removable": true,
                                      "draggable": true,
                                      "rotatable": true,
                                      "resizable": true,
                                      "editable": false,
                                      "custom_index": custom_element[j].parameters.custom_index,
                                        "boundingBoxMode": "limitModify",
                                        boundingBox: boundingBoxJSON,
                                     	 left: custom_element[j].parameters.left,
                                   		top: custom_element[j].parameters.top,
                                     width: custom_element[j].parameters.width,
                                     height: custom_element[j].parameters.height,
                                     rotatable: custom_element[j].parameters.rotatable,
                                     angle: custom_element[j].parameters.angle,
                                     scaleMode: custom_element[j].parameters.scaleMode,
                                     resizable: custom_element[j].parameters.resizable
                                   
                                 });
                                }
                                else
                                {


                                    $(".custom-google-fonts").css("display",'none');
                                    $(".swatches").css("display",'none');
                                    $(".swatches").css("display",'none');
                                    $(".swatches_border").css("display",'none');
                                    $(".select2-container--default .select2-selection--single").css("display",'none');
                                    $(".select2.select2-container.select2-container--default").css("display",'none');

                                    $(".input-text-element").attr("style" ,"text-transform:uppercase")
                                    $(".fpd-tooltip.tooltipstered:nth-child(3)").css("display", "none");
                                    $(".fpd-tooltip.tooltipstered:nth-child(2)").css("display", "none");
                                    $(".fpd-tooltip.tooltipstered:nth-child(1)").addClass('fpd-active');

                                    $(".input-text-element").addClass("Calibri-Font");

                                    
                                  var element_new = yourDesigner.currentViewInstance.addElement("text", custom_element[j].parameters.text, custom_element[j].parameters.text, {
                                      custom_type: "text",
                                      original_text: custom_element[j].parameters.original_text,
                                      custom_text_allignment: custom_element[j].parameters.custom_text_allignment,
                                      colors:true,
                                      color: "#fff",
                                      fontSize: 40,
                                      strokeBlur: custom_element[j].parameters.strokeBlur,
                                      shadowOffsetX: custom_element[j].parameters.shadowOffsetX,
                                      shadowOffsetY: custom_element[j].parameters.shadowOffsetY,
                                      shadowColor:  custom_element[j].parameters.shadowColor,
                                      fill: custom_element[j].parameters.fill,  
                                      "removable": false,
                                      "draggable": false,
                                      "rotatable": false,
                                      "resizable": false,
                                      "editable": false,
                                      "custom_index": custom_element[j].parameters.custom_index,
                                      "boundingBoxMode": "limitModify",
                                      left: 162,
                                      top: custom_element[j].parameters.top,
                                      textTransform:"uppercase",
                                      fontStyle:"italic",
                                      fontWeight:"bold",
                                   
                                 });
                                   

                                }

                                 
                               }  else if(custom_element[j].parameters.custom_type == "image"){         
                                 
                                   var element = yourDesigner.currentViewInstance.addElement("image", custom_element[j].source, custom_element[j].title, {
                                        
                                        "zChangeable": true,
                                        custom_type: "image",
                                       "removable": true,
                                      "draggable": true,
                                      "rotatable": true,
                                      "resizable": true,
                                     "copyable": false,
                          
                                        "boundingBoxMode": "limitModify",
                                        boundingBox: boundingBoxJSON,
                          				scaleX: custom_element[j].parameters.scaleX,
                          				scaleY: custom_element[j].parameters.scaleY,
                                     	 left: custom_element[j].parameters.left,
                                   		top: custom_element[j].parameters.top,
                                     width: custom_element[j].parameters.width,
                                     height: custom_element[j].parameters.height,
                                     rotatable: custom_element[j].parameters.rotatable,
                                     angle: custom_element[j].parameters.angle,
                                     scaleMode: custom_element[j].parameters.scaleMode,
                                     resizable: custom_element[j].parameters.resizable
                                     
                                    });
                                 
                                 //var element = yourDesigner.currentViewInstance.addElement("image", custom_element[j].source, custom_element[j].title, custom_element[j].parameters);
                               } 

                             }
                        } 
            else
              {

                //prj code change
                if(fixed_text.length > 0)
                {;

                       $(".custom-google-fonts").css("display",'none');
                       $(".swatches").css("display",'none');
                       $(".swatches").css("display",'none');
                       $(".swatches_border").css("display",'none');
                       $(".select2-container--default .select2-selection--single").css("display",'none');
                       $(".select2.select2-container.select2-container--default").css("display",'none');
                  
                        $(".input-text-element").attr("style" ,"text-transform:uppercase")
                         $(".fpd-tooltip.tooltipstered:nth-child(3)").css("display", "none");
                         $(".fpd-tooltip.tooltipstered:nth-child(2)").css("display", "none");
                         $(".fpd-tooltip.tooltipstered:nth-child(1)").addClass('fpd-active');

                         $(".input-text-element").addClass("Calibri-Font");


                          var element = yourDesigner.currentViewInstance.addElement("text", "", "", {
                              autoCenter: true,
                              custom_type: "text",
                              original_text: "",
                              custom_text_allignment: 'Horizontal',
                              colors: true,
                              color: fixed_text_color,
                              price: 20,
                              "removable": false,
                              "draggable": false,
                              "rotatable": false,
                              "resizable": false,
                              "editable": true,
                              "topped": true,
                              "custom_index": 0,
                              "boundingBoxMode": textBoundingBoxMode,
                              boundingBox: textBoundingBox,
                              textTransform:"uppercase",
                          });

                     var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);
                     var element = yourDesigner.currentViewInstance.changeColor(currentelement, fixed_text_color);
                     var element1 = yourDesigner.currentViewInstance.setElementParameters({
                      strokeBlur: 3,
                      shadowOffsetX: -3,
                      shadowOffsetY: 3,
                      top:225,
                      left:160,
                      fontSize: 47,
                      shadowColor: fixed_text_border_color,
                      fontFamily: fixed_text_font_family['font_name'],
                      textAlign:'center'

                    }, currentelement);

                }
              //megha code
                if(fixed_text_ipod == "yes")  
                 {

                   $('.swatches').first().hide();
                   
                    $(".fpd-tooltip.tooltipstered:nth-child(3)").css("display", "none");
                     $(".fpd-tooltip.tooltipstered:nth-child(2)").css("display", "none");
                     $(".fpd-tooltip.tooltipstered:nth-child(1)").addClass('fpd-active');
                      var font_family = $('.custom-google-fonts').val() != 0 ? $('.custom-google-fonts').val() : 'Amiri Regular - Font';
                      console.log(font_family+ " font_family");
                      var element = yourDesigner.currentViewInstance.addElement("text", "", "", {
                         autoCenter: true,
                         custom_type: "text",
                         original_text: "",
                         custom_text_allignment: 'Horizontal',
                         colors: true,
                         price: 20,
                         "removable": false,
                         "draggable": false,
                         "rotatable": false,
                         "resizable": false,
                         "editable": true,
                         "topped": true,
                         "custom_index": 0,
                         "boundingBoxMode": textBoundingBoxMode,
                         boundingBox: textBoundingBox,
                         textTransform: "uppercase",
                         strokeBlur: 3,
                         shadowOffsetX: 3,
                         shadowOffsetY: 0,
                         fontSize: 80,
                          fontColor: "#ffffff",
                          fill:"#ffffff",
                        fontFamily : font_family,
                     });
                    var elementsecond = yourDesigner.currentViewInstance.addElement("text", "", "", {
                          title : "second",
                         custom_type: "text",
                         original_text:"sss",
                         custom_text_allignment: 'Horizontal',
                         colors: true,
                          strokeBlur: 3,
                         shadowOffsetX: 3,
                         shadowOffsetY: 0,
                         fontSize: 80,
                         "removable": false,
                         "draggable": false,
                         "rotatable": false,
                         "resizable": false,
                         "editable": false,
                         "boundingBoxMode": "limitModify",
                         textTransform: "uppercase",
                          fontColor: "#ffffff",
                          fill:"#ffffff",
                        fontFamily : font_family,
                      
                     });
                 }
              }
              //end



        });             
                          
                          
                          
       
                          
                          $("#fpd-custom-design-form").validate({
                             onkeyup: function(element) {$(element).valid()},
                              rules: {
        
                              }
                          });
                          
                          
                         $(".character-allowed-count").text(max_character_allowed); 
                         $(".max-image-upload-size").text(max_image_size);
                          
                          
                          
                          $('.input-text-element').prop("maxlength", max_character_allowed);
                          
                           $.validator.addClassRules("input-text-element", { maxlength: max_character_allowed });
                          
                          

                 
                          var len = fonts_order.length;
                          for(i=0; i< len; i++){
                                         fontChangeClassName = fonts_order[i].name.replace(/\s+/g, '');  
                                           var default_selected = fonts_order[i].name == "Amiri Regular - Font" ? 'selected="selected"' : "";
                            $('.custom-google-fonts').append('<option value="' + fonts_order[i].name + '"' + default_selected + ' class="'+fontChangeClassName+'">' + fonts_order[i].name + '</option>');
                          }
          
                          function formatFontElement (state) {
             
                            fontChangeClassName = state.text.replace(/\s+/g, '');
                            var $state = $(
                              '<span' + ' style="font-family:'+fontChangeClassName + '; font-size:16px">' + state.text + '</span>'
                            );
                            return $state;
                          };
                          
                          $('.custom-google-fonts').select2({ templateResult: formatFontElement, templateSelection: formatFontElement});
                          
                          // text color integration
                          	$('.text-color-designer').html('');
                            var len1 = text_color.length;
                          for(i=0; i< len1; i++){
                            $('.text-color-designer').append('  <input type="radio" name="color-radio" value="'+ text_color[i].color_code +'" data-module="color" class="red color-picker" style="background-color: '+ text_color[i].color_code +' !important;">');
                          }                  

                          $('#clear-color-selection').on('click', function() {

                             $('input[name="color-radio"]').prop('checked', false);
                             $('.color-picker').removeClass('active-color-element');
                             var element_value = '#ffffff';
                             var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);
                             var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);
                              if(fixed_text_ipod == 'yes')
                                 {
                                    var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);
                                    var element1 = yourDesigner.currentViewInstance.changeColor(currentelement1, element_value);
                                 }
                           
                         });
                          
                          // text border color integration
                          	$('.text-border-color').html('');
                            var len4 = text_border_color.length;
                          
                          for(i=0; i< len4; i++){
                            
                            $('.text-border-color').append('  <input type="radio" name="border-radio" value="'+ text_border_color[i].color_code +'" data-module="color" class="red border-picker" style="background-color: '+ text_border_color[i].color_code +' !important;">');
                          }                    
                          $('.text-border-color').append('<button type="button" id="clear-border-selection"><img class="clear" src="https://cdn.shopify.com/s/files/1/0687/8537/3458/files/5082-512-_1_-removebg-preview.png?v=1728477036" alt="Girl in a jacket"></button>');

                          // Add click event listener to the Clear button
                          $('#clear-border-selection').on('click', function() {
                            $('.border-picker').removeClass("active-border-color-element");
                            var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);
                          
                                var element = yourDesigner.currentViewInstance.setElementParameters({
                                  strokeBlur: 3,
                                  shadowOffsetX: 2,
                                  shadowOffsetY: 0,
                                  shadowColor: ''
                                }, currentelement);

                            //megha code
                            if(fixed_text_ipod == 'yes')
                             {
                                var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);
            
                                 var element = yourDesigner.currentViewInstance.setElementParameters({
                                   strokeBlur: 3,
                                   shadowOffsetX: 2,
                                   shadowOffsetY: 0,
                                   shadowColor: ''
                                 }, currentelement1);
                             }
                          });
                          
                          // google font size integration
                          	$('.custom-font-size').html('<option value="0">select font size</option>');
                            var len2 = text_size.length;
                          for(i=0; i< len2; i++){
                            var default_selected = text_size[i].size == 45 ? 'selected="selected"' : "";
                            console.log(default_selected);
                            $('.custom-font-size').append('<option value="' + text_size[i].size + '" ' + default_selected + '>' + text_size[i].size + '</option>');
                          }         
                              
                          
                          
                          // google custom font css integration
                          	$('.custom-font-css').html('<option value="0">select custom font css</option>');
                            var len5 = custom_font_css.length;
                          for(i=0; i< len5; i++){
                            $('.custom-font-css').append('<option value="' + custom_font_css[i].id + '">' + custom_font_css[i].name + '</option>');
                          }                 
                          
                          // append radio fields to text-alignment-radio
                          	
                          $('.text-alignment-radio').html('');
                            // $('.text-alignment-radio').append('<input type="radio" name="border-radio1" value="Vertical" data-module="color" class="new-radio text-alignent-radio">  <label class="textlb" for="Vertical"> <i class="fa fa-arrows-v" aria-hidden="true"></i> Vertical</label>  &nbsp; <input type="radio" name="border-radio1" value="Horizontal" data-module="color" class="new-radio-1 text-alignent-radio" checked="checked">  <label class="textlb" for="Vertical"> <i class="fa fa-arrows-h" aria-hidden="true"></i> Horizontal</label>');

                          $('.text-alignment-radio').append('<input type="radio" name="border-radio1" value="Horizontal" data-module="color" class="new-radio-1 text-alignent-radio" checked="checked">  <label class="textlb" for="Vertical"> <i class="fa fa-arrows-h" aria-hidden="true"></i> Horizontal</label>  &nbsp; <input type="radio" name="border-radio1" value="Vertical" data-module="color" class="new-radio text-alignent-radio">  <label class="textlb" for="Vertical"> <i class="fa fa-arrows-v" aria-hidden="true"></i> Vertical</label>');
                          
                          $('input[value="Horizontal"]:first').trigger("click");
                          
                          // add more browse button
                          	
                                            
                          

                          

                            
                            $('.fpd-module').on('change', '.border-picker', function (evt) {
                              
                              
                              $('.border-picker').removeClass("active-border-color-element");
                              $(this).addClass("active-border-color-element");
                              
                                var element_value = $(this).val();

         					//	var currentelement = yourDesigner.currentViewInstance.getElementByID(currentelementId);         
                              var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);         
                              
                              
                              var element = yourDesigner.currentViewInstance.setElementParameters({                               
                                        strokeBlur: 3,
                                        shadowOffsetX: 2,
                                        shadowOffsetY: 0,
                                        shadowColor: element_value    
                                    }, currentelement);     

                              //megha code
                              if(fixed_text_ipod == 'yes')
                               {
                                  var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);
              
                                   var element = yourDesigner.currentViewInstance.setElementParameters({
                                       strokeBlur: 3,
                                       shadowOffsetX: 2,
                                       shadowOffsetY: 0,
                                       shadowColor: element_value
                                   }, currentelement1);
                               }
                              
                            });                    
                            
                            
                            
                           $('.fpd-module').on('change', '.custom-google-fonts,.custom-font-size', function (evt) {
                                var index = 0;
                                var element_name = $(this).attr("data-module");
                                var element_value = $(this).val();
                                var obj = new Object;
                               obj[element_name] = element_value;
                              //obj["fontSize"] = 40; //element_value;
                              
                            // alert(element_value);
                             if(element_name == "fontSize"){
                                element_value = parseInt(element_value, 10);
                                obj[element_name] = element_value;
                              }
                                console.log(obj);
                             //   var currentelement = yourDesigner.currentViewInstance.getElementByID(currentelementId);         
                              var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);         
                             
                             
                             console.log(currentelement);
                              //obj['autoCenter'] = true;
                              	
                            //  console.log(boundingBoxJSON.width - currentelement.left);
                             // console.log(obj[element_name]);
                              
                               if(element_name == "fontSize"){
                                 
                                 //var extra_left = boundingBoxJSON.width + boundingBoxJSON.x  - currentelement.left + currentelement.padding ;
                                 var extra_left = boundingBoxJSON.width - currentelement.aCoords.tr.x ;
                                // var extra_font = element_value > currentelement.fontSize ? (element_value - currentelement.fontSize) : (currentelement.fontSize - element_value);
                                  var extra_font = element_value - currentelement.fontSize; // ? (element_value - currentelement.fontSize) : (currentelement.fontSize - element_value);
                                 console.log(currentelement.aCoords.tr.x);
                                // console.log(currentelement.width);
                                 console.log(extra_left);
                                 console.log(extra_font);
                                  if( extra_left <  extra_font) {
                                        obj['autoCenter'] = true;
                                  }
                              }
                              
                                var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);    
                               // megha code
                             if(fixed_text_ipod == 'yes')
                               {
                                  var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);
                                   var element1 = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement1);
                               }
                            });

                            $('.fpd-module').on('change', '.color-picker', function (evt) {
                                
                              $('.color-picker').removeClass("active-color-element");
                              $(this).addClass("active-color-element");
                              
                                var element_name = $(this).attr("data-module");
                                var element_value = $(this).val();

                                var obj = new Object;
                                obj[element_name] = element_value;
                                console.log(obj);
                           
                              
                              //var currentelement = yourDesigner.currentViewInstance.getElementByID(currentelementId);         
                              var currentelement = yourDesigner.currentViewInstance.getElementByID(globalFrameIDForTextToAlign);         
                                                    
                              
                              
                              console.log(currentelement);
                                var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);   
                              if(fixed_text_ipod == 'yes')
                               {
                                  var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);
                                    var element1 = yourDesigner.currentViewInstance.changeColor(currentelement1, element_value);  
                               }
                            });

                            $('.input-container').on('keyup', '.input-text-element', function (evt) {
                                //evt.stopPropagation();
                                var text = $(this).val();
                                var index = $(this).attr("data-index") ;     
        						//var element_value = '#ffffff';
                               // var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);
                              if(text.length > max_character_allowed){
                                $(this).val(text.substring(0,max_character_allowed));	
                                return;
                              }
                              	
                           //   var font_size = $('.custom-font-size').val() != 0 ?  parseInt($('.custom-font-size').val()) : 45;
                           // var font_family = $('.custom-google-fonts').val() != 0 ?  $('.custom-google-fonts').val() : 'Amiri Regular - Font';
                                
                               //prj code

                                if(fixed_text.length==0){

                                    var font_family = $('.custom-google-fonts').val() != 0 ? $('.custom-google-fonts').val() : 'Amiri Regular - Font';
                                    var font_size = $('.custom-font-size').val() != 0 ? parseInt($('.custom-font-size').val()) : 45;


                                  } else if(fixed_text_ipod =='yes') {
                                        var font_family = $('.custom-google-fonts').val() != 0 ? $('.custom-google-fonts').val() : 'Amiri Regular - Font';
                                       text.toUpperCase();
                      
                                   }else
                                  {
                                     var font_family = fixed_text_font_family['font_name'];
                                     text.toUpperCase();
                                   
                                  }

                              //end 


                                if (typeof elementIdArr[index] == "undefined") {

                                   textBoundingBoxMode = "limitmodify";
                                   textBoundingBox = boundingBoxJSON;
                                  text_alignment = "Horizontal";
                                  if(text_position == "strap" && strap_position == "right_strap"){
                                      textBoundingBoxMode = "clipping";
                                      textBoundingBox = {width: 50, height:350, x:170, y:90};
                                    text_alignment = "Vertical";

                                    	$('input[value="Vertical"]:first').prop("checked", true);
                                         
                                    
                                  } else if(text_position == "strap"){
                                      textBoundingBoxMode = "clipping";
                                    //StrapCurrentFrameBoundingBox = {"width" : StrapCurrentFrame.width, "height": StrapCurrentFrame.height, y: 47, x: -3};
                                      textBoundingBox = {width: 50, height:240, x: 110, y: 150};
                                      text_alignment = "Vertical";

                                    $('input[value="Vertical"]:first').prop("checked", true);
                                  }
                                  
                                  elementIdArr[index] = 0;

                                  
                                   if(fixed_text.length == 0 ){
                                        var element = yourDesigner.currentViewInstance.addElement("text", text, text, {
                                          autoCenter: true,
                                          custom_type: "text",
                                          original_text: text,
                                          custom_text_allignment: text_alignment,
                                          colors: true,
                                          color: "#fff",
                                          price: 20,
                                          "removable": false,
                                          "draggable": true,
                                          "rotatable": true,
                                          "resizable": true,
                                          "editable": false,
                                          "topped": true,
                                          "custom_index": index,
                                          "boundingBoxMode": textBoundingBoxMode,
                                          boundingBox: textBoundingBox,
                                          fontSize: font_size,
                                          fontFamily: font_family
                                        });
                                     var element_value = '#ffffff';
                                     var currentelement = yourDesigner.currentViewInstance.getElementByID(elementIdArr[index]);  
                                      var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);
                                      }
                                      else
                                      {
                                        var element = yourDesigner.currentViewInstance.addElement("text",  text,  text, {
                                          autoCenter: true,
                                          custom_type: "text",
                                          original_text:  text,
                                          custom_text_allignment: text_alignment,
                                          colors: true,
                                          color: fixed_text_color,
                                          price: 20,
                                          "removable": false,
                                          "draggable": false,
                                          "rotatable": false,
                                          "resizable": false,
                                          "editable": false,
                                          "topped": true,
                                          "custom_index": index,
                                          "boundingBoxMode": textBoundingBoxMode,
                                          boundingBox: textBoundingBox,
                                          fontSize: 46,
                                          fontFamily: fixed_text_font_family['font_name']
                                        });
                                        
                                      }


                                    //     console.log(element);
                                    //       console.log(yourDesigner.getElements());
                                    flag = 1;
                                } else {

                                    /*var currentelement = yourDesigner.currentViewInstance.getElementByID(elementIdArr[index]);  
                                    currentelement.original_text = text;
                                     obj = render_allignment(currentelement.custom_text_allignment, currentelement);
                                  	obj.original_text = text;
                                    var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);
                                    //var element_value = '#ffffff';
                                   // var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);
                                    //jQuery('#product-actions').appendTo(".fpd-mainbar");    
                                    // jQuery('#save-container').appendTo(".fpd-mainbar");
                                    // jQuery('#save-container').show();
                                    //yourDesigner.currentViewInstance.getElementByID("");*/

                                  if(fixed_text_ipod == 'yes')
                                   {
                                      var element_value1 = '#ffffff';
                                      var currentelement = yourDesigner.currentViewInstance.getElementByID(elementIdArr[index]);
                                      currentelement.original_text = text;
                                      currentelement.top = "360";
                                      currentelement.left = "381";
                                     if(text.length == 3) {
                                       currentelement.fontSize = "60"; 
                                     } else {
                                      currentelement.fontSize = "70"; 
                                     }
                                      currentelement.set({
                                        angle: 15,
                                      });
                                       obj = render_allignment(currentelement.custom_text_allignment, currentelement);
                                      var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);
                                    //  var element_color = yourDesigner.currentViewInstance.changeColor(currentelement, element_value1);
                                     
                                      var currentelement1 = yourDesigner.currentViewInstance.getElementByID(elementIdArr['undefined']);
                                      currentelement1.original_text = text;
                                       currentelement1.top = "360";
                                      currentelement1.left = "115";
                                      currentelement1.text = text.toUpperCase();
                                      currentelement1.textTransform = "uppercase";
                                      if(text.length == 3) {
                                        currentelement1.fontSize = "60"; 
                                      } else {
                                      currentelement1.fontSize = "70"; 
                                      }
                                       currentelement1.set({
                                        angle: -15
                                      });
                                      obj1 = render_allignment(currentelement1.custom_text_allignment, currentelement1);
                                      var element1 = yourDesigner.currentViewInstance.setElementParameters(obj1, currentelement1);
                                      //   var element_color2 = yourDesigner.currentViewInstance.changeColor(currentelement1, element_value1);
                                   }
                                 else {
                                    // var currentelement = yourDesigner.currentViewInstance.getElementByID(elementIdArr[index]);
                                    // currentelement.original_text = text;
                                    // obj = render_allignment(currentelement.custom_text_allignment, currentelement);
                                    // obj.original_text = text;
                                    // var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);
                                    //  var element = yourDesigner.currentViewInstance.changeColor(currentelement, element_value);
                                     var currentelement = yourDesigner.currentViewInstance.getElementByID(elementIdArr[index]);  
                                    currentelement.original_text = text;
                                     obj = render_allignment(currentelement.custom_text_allignment, currentelement);
                                  	obj.original_text = text;
                                    var element = yourDesigner.currentViewInstance.setElementParameters(obj, currentelement);
                                    
                                  
                                   
                                 }
                                }
                              if(text.length > 0 ) {
                              	 calculate_price("add");
                              } else{
                                 calculate_price("minus");
                              }
                            })

                            //click handler for #store-product-db
                            $('#store-product-db').click(function () {



                                console.log(JSON.stringify(yourDesigner.getProduct()));
                                // //Send data (action and product views) to PHP script
                                // $.post("php/product_in_db.php", { action: 'store', views: JSON.stringify(productDesigner.getProduct()) }, function(data) {
                                //     //check for errors
                                //     if(parseInt(data) > 0) {
                                //         //successfully added
                                //         alert('Product with ID '+data+' stored!');
                                //     }
                                //     else {
                                //         alert('Error: '+data+'');
                                //     }
                                // });
                            });
                        });
                        //print button
                        $('#print-button').click(function () {
                            yourDesigner.print();
                            return false;
                        });
                        //create an image
                        $('#image-button').click(function () {
                            var image = yourDesigner.createImage();
                            return false;
                        });
                        //checkout button with getProduct()
                       /* $('#checkout-button').click(function () {
                            var product = yourDesigner.getProduct();
                            console.log(product);
                            return false;
                        }); */
                        //event handler when the price is changing
                        $yourDesigner.on('priceChange', function (evt, price, currentPrice) {
                            $('#thsirt-price').text(currentPrice);
                        });
                        //save image on webserver
                        $('#save-image-php').click(function () {

                            yourDesigner.getProductDataURL(function (dataURL) {
                                $.post("php/save_image.php", {base64_image: dataURL});
                            });
                        });
                        //send image via mail
                        $('#send-image-mail-php').click(function () {

                            yourDesigner.getProductDataURL(function (dataURL) {
                                $.post("php/send_image_via_mail.php", {base64_image: dataURL});
                            });
                        });
                    }
           
           //search custom style
           function getDetailsByAttr(obj, key, val) {
            var objects = [];
            for (var i in obj) {
                if (!obj.hasOwnProperty(i))
                    continue;
                if (typeof obj[i] == 'object') {
                    objects = objects.concat(getDetailsByAttr(obj[i], key, val));
                } else if (i == key && obj[key] == val) {
                    objects.push(obj);
                }
            }
            return objects;
        }
           
            //search custom style
           function search_index(obj,  val) {
            
            for (var i=0; i<obj.length; i++) {        
              if(obj[i] == val){
                
               return i; 
            }
            }
              
            return -1;
        }
           
           
           //end search custom style
           
           
        // upload browsed image code
                             
           
           function image_upload(obj) {
                
            // $("#upload-image-loader").show();
        	//return 0;
             
             
              var total_image = get_total_image() + 1;
              if(total_image > parseInt(max_image_allowed)){
                	alert("User can not upload more than "+max_image_allowed+" images");
                return;
              }
             
                var fd = new FormData();
             var files = $(obj).parents('.image-upload-item:first').find('input[type="file"]')[0].files[0];
             
                if(!files) {
                    return;
                };
        		
             
             if(files.size/1024 > max_image_size) {
               alert("image must be less then "+ max_image_size + "kb");
               return;
             }
             
             
                  $("#upload-image-loader").show();

             
                fd.append('image', files);        

               //$image_tag.after('<div class="file-upload-loading" style="color:red">Uploading....</div>');

                $.ajax({
                    url: 'https://conceptodohaapp.com/homepage/frontend_browse_image_upload',
                    type: 'post',
                    data: fd,
                    contentType: false,
                    processData: false,
                    success: function (url) {
                      //console.log("URL",url);
                       $(obj).parents('.image-upload-item:first').find('input[type="file"]').val('');

                        var element = yourDesigner.currentViewInstance.addElement("image", url, " Customer Image", {
                                        autoCenter: true, 
                                        "zChangeable": true,
                                        custom_type: "image",
                                       "removable": true,
                                      "draggable": true,
                                      "rotatable": true,
                                      "resizable": true,
                          			"topped": true,	
                          			 "copyable": false,
                                        "boundingBoxMode": "limitModify",
                                        boundingBox: boundingBoxJSON,
                          scaleX:0.2,
                          scaleY:0.2,
                                    });
                           $("#upload-image-loader").hide();
                           global_image_category = "Image Uploaded by customer";

                    },
                });
             
             
             
            }
           
           // to align the text in ver/hori
        function chunk(str, n) {
            var ret = [];
            var i;
            var len;

            for(i = 0, len = str.length; i < len; i += n) {
               ret.push(str.substr(i, n))
            }

            return ret.join("\n");
        };
           
           
           
            function get_total_image(){
             	
              var custom_element = yourDesigner.getElements();
             
              console.log("custom_element for get_total_image() ===> ",custom_element);
              
              
              
              var image_layer_count = 0;
             for(i=1; i < custom_element.length; i++){
               
               console.log("title of image ==> ",custom_element[i].title);
        	    var image_title = custom_element[i].title;
        		
        		console.log("found count ==> ",image_title.toLocaleLowerCase().indexOf("strap"));
        	       

               if(image_title.toLocaleLowerCase().indexOf("strap") == -1)
               {
                 
               if(custom_element[i].custom_type == "image"){
                 image_layer_count = image_layer_count+1;          
               }
                 
               }
               
             }
               return image_layer_count;
             	
             }
           
              
           function insert_text_html_element(obj){
               var index = obj.parents(".fpd-module:first").find(".input-container div:last").index() + 1;
                                     var html = '<div><input data-defaulttext="Enter text" name="custom-text-element'+ index +'" maxlength=10 data-index="' + index +'" placeholder="Enter Text" type="text"   class="input-text-element" /></div>';
                                    obj.parents(".fpd-module:first").find(".input-container").append(html);
           }
           
           function calculate_price(text_add = 'add'){
             	
             var custom_element = yourDesigner.getElements();
             total_price = variant_price; //parseFloat($("#variant_price").text());
             // console.log(total_price);
             var text_layer_flag = 0; var image_layer_flag = 0;
             
             
             for(i=1; i < custom_element.length; i++){
               
               
               /* just check image title is having strap or not start*/
               var selected_image_title = custom_element[i].title;
               if (selected_image_title.toLocaleLowerCase().indexOf("strap")!=-1)
               {
                 console.log("selected image is of strap");
               }
               else
               {
                 console.log("selected image is of paintings");

                 if(custom_element[i].category != "strap_images"){

                   if(custom_element[i].custom_type == "text"){
                     text_layer_flag = 1;

                     if(text_price_type == "per_char"){
                       total_price = total_price + (custom_element[i].text.length * parseFloat(text_price));           
                     }         

                   } else {
                     image_layer_flag = 1;
                     //  total_price = total_price + parseFloat(image_price);

                   }
                   console.log("In calculate_price() for function => ",custom_element[i]);

                 }

               }
               
               /* just check image title is having strap or not end*/

               
             }
             
              if(text_price_type == "fixed"){
                if(text_layer_flag == 1 && image_layer_flag == 0 && text_add == 'add'){
                  	   total_price = total_price + parseFloat(text_price);
                }
                	
               }
        		
              if(image_layer_flag == 1){
                  	   total_price = total_price + parseFloat(image_price);
                }
             
               $("#final_customize_price").text(total_price); 
            
           }
           
           
           
           
             // to show and hide .mainPopup modalll
           
           
        // jQuery(window).load(function() {
        //       alert("window load occurred!");
        // });   
           

           
          
          $(document).ready(function(){
                        var variant_id = $("#ProductSelect-product-template").val();
              			get_custom_design_settings(variant_id);

             
            
            $(document).on("click",".Variant_switch_custom li", function()
            {
              			 // Nm custom code for variant start
                      // $(".customizer_button").hide();
                        var getUrlParameter = function getUrlParameter(sParam) {
                        var sPageURL = window.location.search.substring(1),
                        sURLVariables = sPageURL.split('&'),
                        sParameterName,
                        i;
                        
                        for (i = 0; i < sURLVariables.length; i++) {
                        sParameterName = sURLVariables[i].split('=');
                        
                        if (sParameterName[0] === sParam) {
                        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                        }
                        }
                        return false;
                        };
                        
                        var switch_variant_id = getUrlParameter('variant');
                        console.log("MY Variant :"+switch_variant_id);

                        //ZAID CODE ADDED : CREATE PRODUCT AS PER VARIANT SELECTION
                        // $('#ProductSelect-product-template option[value='+switch_variant_id+']').attr('selected','selected');
                        $('#ProductSelect-product-template').val(switch_variant_id).change();
                  
                      // Nm custom code for variant end
                        console.log("Changed - "+$("#ProductSelect-product-template").val());	
              			var variant_id = $("#ProductSelect-product-template").find(":selected").val();
                        console.log('NEW CHANGED VARIANT VALUE : '+variant_id);
              			get_custom_design_settings(switch_variant_id);	
            	});
            
          });
            
           // to store customize image to show in cart 
           $(document).ready(function(){   
           
             			//checkout button with getProduct()
                        $('.mainPopup').on('click', '#checkout-button', function(e){ 
                            var product = yourDesigner.getProduct();
                           // alert(yourDesigner); 
                            product.extra_note = $('#extra-note').val();
                            var note = $('#extra-note').val();
                            console.log(product);
        // 					console.log("note",note);
                         
                         // return 0;

                            $("#custom-settings-loader").show();
                            $("#checkout-button").prop('disabled','disabled');
                            $(".setting_checkout").show();
        					$('.customize-action-button').css("pointer-events","none")                  
                                            //	return 0;

                          
                          	var draft_variant_id = null;
                          
                            yourDesigner.getProductDataURL(function (dataURL) {
                                $.ajax({
                                    url: 'https://conceptodohaapp.com/homepage/frontend_customize_image_upload_for_cart',
                                  // url: 'https://webdevfolio.com/shopifyapps/Concepto-version2/homepage/frontend_customize_image_upload_for_cart',
                                    type: 'post',
                                    data: {base64_image: dataURL, customize_settings: product},
                                    dataType: 'json',                            
                                    success: function (response) {
                                            console.log(response.preview_image);
                                            console.log(response);     
                                          console.log("nik innn1");    
                                      // now add product to cart
                                    //  return 0;
                                  var variant_id = $("#ProductSelect-product-template").val();
                                      console.log('variant id edreamz',variant_id);
                                  var product_title = $(".get_product_title").text();
                                  // var product_title = "";
                                  var variant_title = $("#ProductSelect-product-template option:selected").html();
                                  var product_customize_image = response.preview_image;    
                                  var customize_image_file_path = response.prev_file_path;        
                                       console.log("product_title-"+product_title+" | variant_title-"+variant_title);
                                      // return 0;

                                    
                                  var total_customize_price = $("#final_customize_price").text();    
                                      
                                   //   alert(total_customize_price);
                                      
                                      // create draft product with final price and title start
                              		  $.ajax({

                                          url: 'https://conceptodohaapp.com/homepage/create_draftproduct_for_addtocart',
                                          type: 'post',
                                          dataType: 'json',
                                          cache: false,
                                          crossDomain : true,                                
                                          data: {product_title: product_title, variant_title: variant_title,total_customize_price:total_customize_price,product_customize_image:product_customize_image,customize_image_file_path:customize_image_file_path},
                                          //dataType: 'json',                            
                                          success: function (response_draft) {
                                            console.log("draft");
                                            console.log(response_draft);
                                            console.log(response_draft.id);
                                            console.log(response_draft.variants);
                                            console.log(response_draft.variants[0].id);
                                            
                                            
                                            if(response_draft)
                                            {
                                            	draft_variant_id = response_draft.variants[0].id;
        										console.log(response_draft.variants[0].id);
                                              
                                              // add to cart draft product start

                                              var  properties_data = '{"Original Image": "'+product[0]['thumbnail']+'",';            
                                                                        
                                  for(var i=0; i < product[0]['elements'].length; i++)
                                  {
                                        if(product[0]['elements'][i]['type'] == 'text')
                                        {
                                               //properties_data += '"Text No.": "1",';                                  
                                               properties_data += '"Text": "'+$("input[name=custom-text-element_1]").val()+'",';                                   
                                               properties_data += '"Font Family": "'+product[0]['elements'][i]['parameters']['fontFamily']+'",';                                  
                                               properties_data += '"Font Size": "'+product[0]['elements'][i]['parameters']['fontSize']+'",';                                   
                                               properties_data += '"Text Color Code": "'+product[0]['elements'][i]['parameters']['fill']+'",';                                  
                                               properties_data += '"Text Border Color Code": "'+product[0]['elements'][i]['parameters']['shadowColor']+'",';                                  
                                               properties_data += '"Text Alignment": "'+product[0]['elements'][i]['parameters']['custom_text_allignment']+'",';
                                        }
                                        else
                                        {
                                  
                                               properties_data += '"Image On case": "2",';                                  
                                               properties_data += '"Image Name": "'+product[0]['elements'][i]['title']+'",';                                  
                                               properties_data += '"Image Source": "'+product[0]['elements'][i]['source']+'",'; 
                                        }
                                        
                                  } 
                                  properties_data += '"preview_image": "'+response.preview_image+'",'; 
                                  //properties_data += '"response_log_id": "'+response.log_id+'",'; 
                                  properties_data += '"Total Price": "'+total_customize_price+'",';
                                  properties_data += '"note": "'+note+'",';
                                  properties_data += '"base_variant_id": "'+variant_id+'"';
                                  properties_data += '}';

                                  console.log('PROPERTIES TEST ---'+properties_data);
                                              
                                  $.post("/cart/add.js",
                                   {
                                    quantity:1,
                                    //id:variant_id,
                                    id:draft_variant_id,
                                    // properties: {
                                    //   'customize_settings': product,
                                    //   'preview_image' : response.preview_image,
                                    //   'total_customize_price': total_customize_price,
                                    //   'note' : note,
                                    //   'base_variant_id':variant_id
                                    // }
                                     properties: jQuery.parseJSON(properties_data)
                                    },
                                     function(data,status){

                                    
                                          if(data.status == 422)
                                          {
                                              console.log("You can't add more Demo Product to the cart.");
                                              return 0; 
                                          }
                                          else
                                          {
                                          console.log("data - "+data);

                                          }
                                    
                                    	// redirect to cart part
        								window.location.replace("/cart");
                                    
                                    
                                    
                                  },"json");
                                          
                                              
                                              
                                              
                                              // add to cart draft product end
                                              
                                              
                                              
                                              
                                              
                                            }
                                            
                                          }
                                      });

                                      //	return 0;
                                      
                                      
                                      // create draft product end                                                                                                                                                   
                                    }
                                 });
                             });
                            return false;
                        }); 
                    });

        function editormode_chk(){
          if(editor_mode_hide && editor_mode_hide.indexOf('painting') !== false){
            return true;
          } 

          return false;
        }

        function editormode_chk1(){
          if(file_uploade_hide && file_uploade_hide.indexOf('hide') !== false){
            jQuery('.custom-image-upload').remove();
             $('.image-upload-item').css("display","none");
            return true;
          } 

          return false;
        }
